import { render } from "./po-detail.vue?vue&type=template&id=25779956&scoped=true"
import script from "./po-detail.vue?vue&type=script&lang=js"
export * from "./po-detail.vue?vue&type=script&lang=js"

import "./po-detail.vue?vue&type=style&index=0&id=25779956&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25779956"]])

export default __exports__